import { render, staticRenderFns } from "./Mymenu.vue?vue&type=template&id=f67c8e98&scoped=true"
import script from "./Mymenu.vue?vue&type=script&lang=js"
export * from "./Mymenu.vue?vue&type=script&lang=js"
import style0 from "./Mymenu.vue?vue&type=style&index=0&id=f67c8e98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67c8e98",
  null
  
)

export default component.exports